<script>
  import {rfc3339} from './util.js';
  import {
    localDates,
  } from './settings.js';

  export let ts;
  export let millis = false;
</script>

<span>
  {rfc3339(ts, millis, $localDates)}
</span>

<style>
  span {
    font-family: 'Iosevka Custom Web';
  }
</style>
